import React from 'react';
import PropTypes from 'prop-types';
import { BlockRenderer } from './BlockRenderer';
import { ContentPropType } from './contentPropTypes';

/**
 * Main component that renders structured content blocks from the API
 * Converts structured JSON content into proper React JSX with VA Design System components
 * @param {Array} content - Array of content blocks to render
 * @param {boolean} removeLastMargin - Removes the bottom margin of the last block
 */
export const TrackedItemContent = ({ content, removeLastMargin = false }) => {
  if (!content || !Array.isArray(content)) {
    return null;
  }

  return (
    <>
      {content.map((block, idx) => (
        <BlockRenderer
          key={idx}
          block={block}
          removeBottomMargin={removeLastMargin && idx === content.length - 1}
        />
      ))}
    </>
  );
};

TrackedItemContent.propTypes = {
  content: ContentPropType,
  removeLastMargin: PropTypes.bool,
};
